module.exports = __webpack_public_path__ + "static/img/end02.379d8f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/end02.jpg
// module id = 1433
// module chunks = 0